export const i18n_en = {
  action: {
    search: 'Search',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    mark_lessons: 'Mark lessons',
    mark_lesson: 'Mark lesson',
    clear_search: 'Clear',
    click_to_confirm_remove: 'Confirm',
    save_changes: 'Save changes',
    save_lesson: 'Save lesson',
    new_lesson: 'New lesson',
    import_file: 'Import',
    open_drivercard: 'Open driver card',
    print_drivercard_pdf: 'Print driver card',
    print_drivercard_pdf_course: 'Print course driver cards',
  },
  app: {
    cancel: 'Cancel',
    confirm_logout: 'Are you sure you want to log out?',
    civil_driving_licenses: 'Civil driving licenses',
    missing_perm: 'Check permissions',
    description: 'Description',
    app_name: 'PVKULTU opetuksen seuranta',
    username: 'Username',
    password: 'Password',
    last_name: 'Last name',
    name: 'Name',
    not_found: '404 Not found',
    login: 'Login',
    login_failed: 'Login failed. Please check your credentials.',
    logout: 'Logout',
    react_error: 'Something went wrong',
    lessons_booking: 'Lessons booking',
    lessons_status: 'Lessons status',
    lessons_edit: 'Lessons',
    theory_lessons: 'Theory lessons',
    theory_lessons_booking: 'Theory lessons booking',
    training_lessons: 'Training',
    training_lessons_booking: 'Training lessons booking',
    trafi_id: 'Trafi Id',
    driving_lessons: 'Driving lessons',
    driving_lessons_booking: 'Driving lessons booking',
    select_unit: 'Select unit',
    yes: 'Yes',
    previous_entries: 'Previous entries',
    entries: 'Entries',
    undones: 'Undones',
    edit_theorylesson_entry: 'Edit theory lesson entry',
    edit_traininglesson_entry: 'Edit training lesson entry',
    edit_drivinglesson_entry: 'Edit driving lesson entry',
    supervisor: 'Supervisor',
    lesson_completed: 'Lesson completed',
    remove_lesson_entry: 'Remove entry',
    previous_undone: 'Undone entries',
    previous_complete: 'Completed entries',
    pro_theory: 'Pro theory',
    pro_driving: 'Pro driving',
    theory: 'Theory',
    driving: 'Driving',
    training: 'Training',
    lesson_status: 'Lesson status',
    active: 'Active',
    completed: 'Completed',
    failed: 'Failed',
    compensated: 'Compensated',
    undone: 'Undone',
    dropped_out: 'Dropped out',
    missing: 'Missing',
    save: 'Save',
    complete_undone_theorylesson: "Complete theory lesson",
    complete_undone_traininglesson: "Complete training lesson",
    select: 'Select',
    study_overview: 'Study overview',
    data_import: 'Import data',
  },
  search: {
    course_number: 'Course',
    course_year: 'Year',
    course_unit: 'Unit',
    applicant_name: 'Applicant',
    applicant_status: 'Status',
    team: 'Team',
    exam_class: 'Class',
    lesson_type: 'Type',
    lesson_date: 'Lesson date',
    missing_lesson: 'Missing lesson',
    select_missing_lesson: 'Select lesson...',
    lesson_type_all: 'All',
    lesson: 'Lesson',
    select_lesson_type: 'Select lesson type...',
    show_only_undone: 'Show only undone',
    theory_course_number: 'Course',
    only_applicants_with_undone: 'Show only applicants with undone',
    other_courses: 'Other courses',
    include_active: "Active only",
    include_dropped: "Include dropped"
  },
  datatable: {
    independent_training: 'Independent training',
    person_transport: 'Person transport',
    lesson_type: 'Type',
    exam_class: 'Class',
    topic: 'Topic',
    completed: 'Completed',
    compensated: 'Compensated',
    undone: 'Undone',
    undone_entry: 'Undone entry',
    lesson_description: 'Lesson description',
    compulsory_lessons: 'Compulsory',
    additional_lessons: 'Additional',
    course_lessons: 'Only course related',
    course: 'Course',
    additional_info: 'Additional info',
    permission_status: 'Permission status',
    permission_status_legend: 'Show legend',
  },
  message: {
    add_entries_failed: 'Error while saving new entries',
    add_entries_success: 'Entries saved successfully!',
    check_date_form: 'Check the date! The date should be in the form mm/dd/yyyy',
    no_applicants_found: 'No applicants found',
    update_lesson_entry_error: 'Error while saving entry',
    remove_lesson_entry_error: 'Error while removing entry',
    update_lesson_entry_success: 'Updated successfully!',
    remove_lesson_entry_success: 'Removed successfully!',
    update_applicant_error: 'Error updating applicant data',
    update_applicant_success: 'Update success',
    no_lessons_found: 'No lessons found',
    import_data_success: 'File "%{name}" succesfully imported',
  },
  applicant: {
    active: 'Active',
    passive: 'Dropped out',
    theory_lessons_completed: 'Theory lessons completed',
    training_lessons_completed: 'Training lessons completed',
    pre_driving_lessons_completed: 'Required driving lessons completed',
    driving_lessons_completed: 'Driving lessons completed',
    has_no_pro_perm: 'No professional qualification',
    has_pro_perm: 'Has professional qualification',
    independent_driving_lessons_badge: 'A',
    independent_driving_lessons_incomplete: 'Independent driving lessons incomplete',
    independent_driving_lessons_completed: 'Lessons required for independent driving completed',
    independent_driving_lessons_disabled: 'Editable only in KULTI',
    independent_handling_badge: 'K',
    independent_handling_eligible: 'Approve independent handling training permission',
    independent_handling_approved: 'Independent handling training approved',
    has_adr_perm: 'Has a valid ADR permission',
    has_adr_perm_for_classes: 'Has a valid ADR permission for classes',
    no_active_course: 'No active course',
    applicant_passive: 'Applicant is passive',
    person_transport_perm_badge: 'H',
    person_transport_perm_approved: 'Person transport permission approved',
    person_transport_perm_waiting_approval: 'Person transport permission sent to KULTI',
    person_transport_perm_kulti_approval_pending: "Waiting for approval",
    person_transport_perm_kulti_approved: "Approved",
    person_transport_perm_eligible: 'Send person transport permission to KULTI for approval',
    person_transport_perm_not_eligible: 'Person transport permission lessons incomplete',
    person_transport_perm_disabled_not_eligible: 'Required lessons for persol transport permission not completed',
    person_transport_perm_disabled_not_teacher: 'Only instructors are allowed to approve',
    person_transport_perm_disabled_kulti_already_approved: "Person transport permission already approved",
  },
  driving_lesson: {
    driving_lesson_details: 'Fill in the driving lesson details',
    lesson_date: 'Lesson date',
    start_time: 'Began at',
    end_time: 'Ended at',
    beneficial_driving: 'Beneficial driving',
    class: 'Class',
    subject: 'Subject',
    plate_number: 'Plate number',
    kilometrage: 'Kilometrage',
    additional_info: 'Additional info',
    add_lesson_pause: 'Add new lesson pause',
    remove_lesson_pause: 'Remove',
    add_lesson: 'Add new lesson',
    loading: 'Loading time',
    waiting: 'Waiting time',
    other: 'Other',
    lesson_pause_type: 'Lesson pause type',
    add_new_driving_lesson: 'Add new driving lesson',
    pause_start_time: 'Began at',
    pause_end_time: 'Ended at',
    lessonTopics: 'Lesson topics',
    applicant_info_multiple: 'Selected %{count} applicants'
  },
  edit_lesson: {
    description: 'Lesson description',
    description_short: 'Short name',
    topic: 'Topic',
    exam_classes: 'Exam classes',
    lesson_type: 'Lesson type',
    independent_training: 'Before independent training',
    person_transport: 'Required for person transport',
    save_success: 'Lesson saved successfully',
    save_failure: 'Saving lesson failed: ',
    remove_success: 'Lesson removed successfully',
    remove_failure: 'Removing lesson failed: ',
    remove: 'Remove',
    remove_confirmation: 'Do you really want to remove this lesson?',
    additional_lesson: 'Additional lesson',
    order_number: 'Order number'
  },
  dataimport: {
    pick_file: "File",
    failure_xml: "File content not well formed",
    failure_type: "Unknown message type in file",
    failure: "Unable to import file",
  },
  driver_card: {
    title: "Driver card",
    person: "Person",
    trafi_id: "Trafi id",
    last_name: "Last name",
    first_names: "First names",
    civil_driving_licence: "Civil driving licence",
    course: "Course",
    medical_certificate: "Medical certificate",
    current_medical_state: "Current medical state",
    current_medical_state_date: "Date",
    driver_exam_information: "Drivers exam information",
    exam_class: "Exam class",
    driving_exam_count: "Driving exam count",
    theory_exam_count: "Theory exam count",
    driving_training: "Driving training",
    name: "Name",
    lesson_time: "Training time",
    total: "Total",
    independent_training: "Independent training",
    guided_training: "Guided training",
    training: "Training",
    supervisor: "Supervisor",
    topic: "Topic",
  },
  course: {
    selected_course: "Selected course",
    no_selection: "Select course",
    select: "Select",
    not_found: "Selected course not exists",
  }
};


// WEBPACK FOOTER //
// ./src/i18n_en.js